const translations = {
  "slider.appealsNotFound": "აქტიური მიმართვები ვერ მოიძებნა",
  "slider.requestsNotFound": "აქტიური მოთხოვნები ვერ მოიძებნა",
  "slider.consultationsNotFound": "აქტიური კონსულტაციები ვერ მოიძებნა",
  "slider.detailedInformation": "დეტალური ინფორმაცია",
  "slider.uploadDocumentation": "იხილე ნაკლული დოკუმენტაცია",
  "slider.request": "მოთხოვნა",
  "slider.medicalService": "ჩატარებული სამედიცინო მომსახურება",
  "slider.ambulatory": "ამბულატორია",
  "slider.policyNumber": "პოლისის ნომერი",
  "slider.createDate": "შექმნის თარიღი",
  "slider.requestedAmount": "მოთხოვნილი თანხა",
  "slider.reimbursedAmount": "ანაზღაურებულია",
  "slider.gel": "ლარი",
  "slider.consultationDetails": "კონსულტაციის დეტალები",
  "slider.consultationType": "კონსულტაციის ტიპი",
  "slider.shareInfo": "გაუზიარე დანიშნულება/კვლევის პასუხები ექიმს",
  "slider.cancelConsultation": "კონსულტაციის გაუქმება",
  "slider.noConsultations": "აქტიური დაგეგმილი კონსულტაცია არ გიფიქსირდებათ",
  "slider.bookingAppointment": " ექიმთან ჩაწერა",
  "slider.visitDetails": "ვიზიტის დეტალები",
  "slider.cancelVisit": "ვიზიტის გაუქმება",
  "slider.shareDetailsToDoc": "გაუზიარე დანიშნულება/კვლევის პასუხები ექიმს",
  "slider.formDetails": "ფორმა 100 / ექიმის დანიშნულება",
  "slider.additionalInputDetails": "სხვა (კვევის პასუხი, რენტგენი, ა.შ.) ",
  "slider.sending": "გაგზავნა",
  "slider.outpatientDentistryMedicines":
    "ამბულატორია/სტომატოლოგია/მედიკამენტები",
  "slider.hospitalizationLabor": "ჰოსპიტალიზაცია/მშობიარობა",
  "slider.other": "სხვა",
  "slider.consultationCode": "ჯავშნის კოდი",
  "service.compensatedAmount": "ანაზღაურებული თანხა",
  "service.coveragePercent": "თანაგადახდის %",
  "service.createDate": "შექმნის თარიღი",
  "service.medicament": "მედიკამენტი",
  "service.payedAmmount": "გადახდილი (მოთხოვნილი) თანხა",
  "service.policyService": "პოლისის სერვისი",
  "service.provider": "სამედიცინო დაწესებულება",
  "service.treatment": "მიღებული მომსახურება",
  "service.rejectComment": "კორექტირების კომენტარი",
  "service.leaveUsComment": "დაგვიტოვე კომენტარი",
  "service.correctionCommentDetailedReason": "კორექტირების დეტალური მიზეზი",
  "slider.requestAppeal": "მიმართვის მოთხოვნა",
  "slider.requestCompensation": "ანაზღაურების მოთხოვნა",
  "slider.requestAppointment": "ექიმთან ჩაწერა",
};

export default translations;
